// extracted by mini-css-extract-plugin
export default {"width-100":"eY7gg7kPoB4a_5q3_FNA","ellipsis":"GjdSaY_fMKg4yFUo3qTh"};